/* Custom cursor: an exact center dot + a lagging outline ring.
   Skips touch devices and reduced-motion users (keeps the native cursor). */
(function () {
  if (!window.matchMedia) return;
  var fine = window.matchMedia('(pointer: fine)').matches;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || reduce) return;

  var ring = document.createElement('div');
  ring.className = 'bcur';
  var dot = document.createElement('div');
  dot.className = 'bcur-dot';

  function mount() {
    document.body.appendChild(ring);
    document.body.appendChild(dot);
    document.documentElement.classList.add('has-ball-cursor');
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  var mx = window.innerWidth / 2;
  var my = window.innerHeight / 2;
  var rx = mx;
  var ry = my;
  var shown = false;
  var hoverSel = 'a, button, [role="button"], label, summary, .swiper-bullet, input, select, textarea';

  document.addEventListener('mousemove', function (e) {
    mx = e.clientX;
    my = e.clientY;
    dot.style.transform = 'translate(' + mx + 'px,' + my + 'px)';
    if (!shown) {
      shown = true;
      ring.style.opacity = '1';
      dot.style.opacity = '1';
    }
  }, { passive: true });

  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && !e.toElement) {
      ring.style.opacity = '0';
      dot.style.opacity = '0';
      shown = false;
    }
  });

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) ring.classList.add('is-hover');
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target.closest && e.target.closest(hoverSel)) ring.classList.remove('is-hover');
  });
  document.addEventListener('mousedown', function () { ring.classList.add('is-down'); });
  document.addEventListener('mouseup', function () { ring.classList.remove('is-down'); });

  (function loop() {
    rx += (mx - rx) * 0.2;
    ry += (my - ry) * 0.2;
    ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
    requestAnimationFrame(loop);
  })();
})();
